export const emailValidations = $axios => ({
  create: (tenantSlug, params) => $axios.$post(`/public/workspaces/${tenantSlug}/email_validations`, params),
});
